module.exports = __webpack_public_path__ + "img/users.8c885b7c.svg";